import * as React from "react";
import { IAuthContext } from "./types";

const AuthContext = React.createContext<IAuthContext | undefined>(undefined);
AuthContext.displayName = "AuthContext";

export default AuthContext;
